import FormState from "./FormState";
import FormValidationErrors from "./FormValidationErrors";

export default class AjaxForm {

	constructor() {

		var $this = this;

		$( "body" ).on( "submit", ".js-ajax-form", function(e) {

			e.preventDefault();

			$this.maybeShowRefreshLoader($(this));

			ClearValidationErrors($(this));
		
			if ($(this).attr('method') == 'POST') {

				$this.post($(this));

			} else {

				$this.get($(this));

			}
			
		});

	}

	maybeShowRefreshLoader(obj) {

		if (typeof obj.attr('data-refresh-loader') != 'undefined') {

			var refresh_target = obj.attr('data-refresh-loader');

			$(refresh_target).prepend('<div class="loading-overlay"><i class="fas fa-spinner fa-spin"></i></div>');

		}

	}

	get(obj) {

		var $this = this;

		var url = obj.attr('action') + '/?' + obj.serialize();

		axios.get(url)
		.then(function (response) {

			$this.processResponse(obj, response);

		})
		.catch(function (error) {

			$this.processError(obj, error);
			
		});

	}

	post(obj) {

		var $this = this;

		axios.post(obj.attr('action'), obj.serialize())
		.then(function (response) {

			$this.processResponse(obj, response);

		})
		.catch(function (error) {

			$this.processError(obj, error);
			
		});

	}

	processResponse(obj, response) {

		this.maybeRefreshElement(obj, response);

		this.maybeClearInput(obj);

		new FormState().enable(obj);

		this.maybeShowFlashMessage(obj, response);
		
		this.maybeRedirect(obj, response);
			
	}

	maybeClearInput(obj, response) {

		if (typeof obj.attr('data-clear-input') != 'undefined') {

			obj.find('.form-control').val("").change();

			obj.find('.js-files').html('');
			
		}

	}

	maybeRefreshElement(obj, response) {

		var refresh = response.data.refresh;

		if (typeof refresh == "undefined") {
			return;
		}

		if (typeof refresh.target == "undefined") {

			var $this = this;

			refresh.forEach(function(item) {
				$this.refreshElement(item);
			});

			return;
		}

		this.refreshElement(refresh);

	}

	refreshElement(refresh) {

		$(refresh.target).html(refresh.view);

	}

	maybeShowFlashMessage(obj, response) {

		var flashData = response.data.flash;

		if (typeof flashData != "undefined") {

			return new Flash.custom(JSON.parse(flashData));

		} 		

	}

	maybeRedirect(obj, response) {

		var redirect = response.data.redirect;

		if (typeof redirect != "undefined") {

			if (response.data.flash) {

				// give the user time to read the flash message

				setTimeout( function() {

					window.location.href = redirect;

				}, 2000);

			} else {

				window.location.href = redirect;

			}


			// window.location = redirect;
		 //    window.location.reload();

		}

	}

	processError(obj, error) {

		new FormState().enable(obj);

		new FormValidationErrors(obj).show(error);

	}

}